export default __webpack_public_path__ + "static/media/sempre-visto.f8974504.png";